import React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { Box, Button, Stack, Typography, useTheme } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { useNavigate } from 'react-router-dom';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import CustomerDataDrid from './components/customer-data-grid';
import { RootState } from 'plugins/store';
import { useAppDispatch, useAppSelector } from 'common/hook';
import CustomerConstants from './constants';
import { exportClient } from 'services/clientManagement.service';
import { handleError } from 'utils/helpers';
import { setIsLoading } from 'slices/loadingSlice';

const Customer: React.FC = () => {
    const theme = useTheme();
    const navigate = useNavigate();

    const customersSearchForm = useAppSelector(
        (state: RootState) => state.customer.customersSearchForm
    );
    const dispatch = useAppDispatch();

    const handleExport = async () => {
        try {
            dispatch(setIsLoading(true));
            const params = { ...customersSearchForm };
            if (
                customersSearchForm.status?.includes(
                    CustomerConstants.status.ALL
                )
            ) {
                params.status = [];
            }
            if (
                customersSearchForm.source?.includes(
                    CustomerConstants.source.ALL
                )
            ) {
                params.source = [];
            }
            const excelData = await exportClient({
                page: 1,
                q: {
                    search_with_key_cont: params.searchKeyWord,
                    status_in: params.status?.join(','),
                    created_by: params.source?.join(','),
                    start_date: params.startDate,
                    end_date: params.endDate,
                },
            });
            // Get the filename from Content-Disposition header if available
            const filename = 'customers.xlsx';

            // Create blob URL and trigger download
            const url = window.URL.createObjectURL(new Blob([excelData]));
            const link = document.createElement('a');
            link.href = url;
            link.download = filename;
            document.body.appendChild(link);
            link.click();

            // Clean up
            document.body.removeChild(link);
            setTimeout(() => {
                window.URL.revokeObjectURL(url);
                dispatch(setIsLoading(false));
            }, 100);
        } catch (error) {
            handleError(error);
            dispatch(setIsLoading(false));
        }
    };
    return (
        <Box mt={5}>
            <Box mb={'40px'}>
                <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="end"
                >
                    <Typography
                        variant="h3"
                        component="h3"
                        fontSize={28}
                        fontWeight={'bold'}
                        lineHeight={'34px'}
                        color={theme.palette.primary.main}
                    >
                        Khách hàng
                    </Typography>
                    <Stack direction="row" spacing={2}>
                        <Button
                            onClick={() => navigate('/admin/customer/add')}
                            sx={{
                                minWidth: '230px',
                                fontSize: '20px',
                                textTransform: 'none',
                                fontWeight: '700',
                                lineHeight: '24.2px',
                                borderRadius: '39.06px',
                            }}
                            variant="contained"
                            startIcon={
                                <AddIcon sx={{ fontSize: '40px !important' }} />
                            }
                        >
                            Thêm mới
                        </Button>
                        <Button
                            variant="contained"
                            size="large"
                            sx={{
                                textTransform: 'none',
                                width: '177px',
                                height: '60px',
                                borderRadius: '39px',
                                padding: '0px',
                            }}
                        >
                            <Box
                                component={'div'}
                                width={'100%'}
                                height={'100%'}
                                sx={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    gap: '11px',
                                }}
                                onClick={handleExport}
                            >
                                <FileDownloadOutlinedIcon
                                    sx={{
                                        fontSize: '40px !important',
                                        color: 'inherit',
                                    }}
                                />
                                <Typography
                                    fontSize={20}
                                    component={'span'}
                                    fontWeight={'bold'}
                                    lineHeight={'24px'}
                                >
                                    Xuất
                                </Typography>
                            </Box>
                        </Button>
                    </Stack>
                </Box>
            </Box>
            <Card
                elevation={0}
                sx={{
                    borderRadius: '26px',
                }}
            >
                <CardContent
                    sx={{
                        padding: 0,
                        paddingBottom: '0 !important',
                    }}
                >
                    <CustomerDataDrid />
                </CardContent>
            </Card>
        </Box>
    );
};

export default Customer;
